// Spinner — presentation primitive. Pure SVG, no react-bootstrap.
// Props:
//   size:  'sm'|'md'|'lg'   (default 'md')
//   label: string           (sr-only accessible label; default 'Завантаження')
//   className, ...rest

function Spinner({
  size = 'md',
  label = 'Завантаження',
  className = '',
  ...rest
}) {
  const classes = [
    'ui-spinner',
    `ui-spinner--${size}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <span
      role="status"
      aria-live="polite"
      className={classes}
      {...rest}
    >
      <svg
        className="ui-spinner__svg"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          className="ui-spinner__track"
          cx="12"
          cy="12"
          r="9"
          fill="none"
          strokeWidth="3"
        />
        <circle
          className="ui-spinner__head"
          cx="12"
          cy="12"
          r="9"
          fill="none"
          strokeWidth="3"
          strokeLinecap="round"
          pathLength="100"
        />
      </svg>
      <span className="ui-spinner__sr">{label}</span>
    </span>
  );
}

export default Spinner;
